import { useDataValue, useDataChange } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props) {
  let boardId = useDataValue({
    context: 'event_action',
    path: 'data.new_task.board_id',
    viewPath: props.viewPath,
  })
  let setBoardId = useDataChange({
    context: 'event_action',
    path: 'data.new_task.board_id',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    if (!boardId) return
    // Check if action's board exists in this location.
    // It might not if we consider the copy of automations between locations.
    let isBoardPresent = value?.find(item => item.id === boardId)
    if (!isBoardPresent) {
      setBoardId(null)
      return
    }
  }
}
